/* Cada entorno usa el mismo logo con un color propio, para distinguirlos en las
   pestañas. El mismo color identifica la vertical adentro de la app: el sufijo
   del nombre ("Udream App CRM") va pintado con él.

   `color` es para fondos oscuros y `colorClaro` para fondos claros: el verde que
   se lee sobre el degradé del menú desaparece sobre el papel blanco del login. */
const ENTORNOS = {
  admin: {
    favicon: '/favicon-admin.png', icono: '/icon-admin-180.png', titulo: 'Udream App Admin',
    sufijo: 'Admin', color: '#eab63f', colorClaro: '#a87708',
  },
  portal: {
    favicon: '/favicon-portal.png', icono: '/icon-portal-180.png', titulo: 'Udream App Clientes',
    sufijo: 'Clientes', color: '#6faaf7', colorClaro: '#1a5fbd',
  },
  crm: {
    favicon: '/favicon-crm.png', icono: '/icon-crm-180.png', titulo: 'Udream App CRM',
    sufijo: 'CRM', color: '#3ad598', colorClaro: '#0b8259',
  },
};

export const entornoActual = () => {
  const h = window.location.hostname;
  if (h.startsWith('admin.')) return 'admin';
  if (h.startsWith('clientes.')) return 'portal';
  return 'crm';
};

export function aplicarIdentidad() {
  const e = ENTORNOS[entornoActual()];
  // el index trae varios iconos con distintos tamaños: se sacan todos y queda uno solo
  document.querySelectorAll('link[rel~="icon"], link[rel="apple-touch-icon"], link[rel="shortcut icon"]')
    .forEach(l => l.parentNode.removeChild(l));
  const agregar = (rel, href, attrs = {}) => {
    const l = document.createElement('link');
    l.rel = rel;
    l.href = href + '?v=4';
    Object.entries(attrs).forEach(([k, v]) => l.setAttribute(k, v));
    document.head.appendChild(l);
  };
  agregar('icon', e.favicon, { type: 'image/png' });
  agregar('apple-touch-icon', e.icono);
  document.title = e.titulo;
}

export const iconoDelEntorno = () => ENTORNOS[entornoActual()].icono;

// El nombre de la vertical y su color, para pintar "Udream App <vertical>"
export const marcaDelEntorno = () => {
  const { sufijo, color, colorClaro } = ENTORNOS[entornoActual()];
  return { sufijo, color, colorClaro };
};
